<template>
  <el-dialog
    class="reset-password-dialog common-dialog"
    title="重置密码"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    top="25vh"
    @close="closeDialog"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="rules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="新密码" prop="password">
        <el-input
          v-model.trim="editForm.password"
          type="password"
          :maxlength="20"
          autocomplete="off"
          show-password
          @change="handlePwChange"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="newPassword">
        <el-input
          v-model.trim="editForm.newPassword"
          type="password"
          :maxlength="20"
          autocomplete="off"
          show-password
          @change="handlePwChange"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" class="dialogButtonB" @click="submitForm('editForm')">
        确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
import { handleEncrpty } from '@/utils/sm4Func'
export default {
  name: 'UpdatePassword',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 80
  },
  data() {
    // 新密码复杂度验证：大写字母、小写字母、数字、特殊字符中三种组合，长度为8-20位
    const validatePasswordComplexity = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
        return
      }

      // 检查长度
      if (value.length < 8 || value.length > 20) {
        callback(new Error('密码长度为8-20位'))
        return
      }

      // 检查是否与用户名相同或包含用户名
      if (this.username && value.toLowerCase() === this.username.toLowerCase()) {
        callback(new Error('密码不能与用户名相同'))
        return
      }
      if (this.username && value.toLowerCase().includes(this.username.toLowerCase())) {
        callback(new Error('密码不能包含用户名'))
        return
      }

      // 检查复杂度：大写字母、小写字母、数字、特殊字符中至少三种组合
      let hasUpperCase = /[A-Z]/.test(value)
      let hasLowerCase = /[a-z]/.test(value)
      let hasNumber = /[0-9]/.test(value)
      let hasSpecialChar = /[^A-Za-z0-9]/.test(value)

      let complexityCount = 0
      if (hasUpperCase) complexityCount++
      if (hasLowerCase) complexityCount++
      if (hasNumber) complexityCount++
      if (hasSpecialChar) complexityCount++

      if (complexityCount < 3) {
        callback(new Error('密码必须包含大写字母、小写字母、数字、特殊字符中的三种组合'))
        return
      }

      callback()
    }

    // 确认密码验证：必须与新密码一致
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入确认密码'))
        return
      }
      if (value !== this.editForm.password) {
        callback(new Error('确认密码必须与新密码一致'))
        return
      }
      callback()
    }
    return {
      dialogVisible: false,
      editForm: {
        newPassword: '',
        password: '',
        id: ''
      },
      rules: {
        password: [
          { required: true, validator: validatePasswordComplexity, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      adaptationVars: {
        formLabelWidth: 80
      },
      username: ''
    }
  },
  watch: {
    // 当用户名变化时，重新验证新密码字段
    username() {
      if (this.$refs.editForm) {
        // 如果新密码字段有值，重新验证
        if (this.editForm.password) {
          this.$refs.editForm.validateField('password')
        }
      }
    },
    // 当新密码变化时，重新验证确认密码字段
    'editForm.password'() {
      if (this.$refs.editForm) {
        // 如果确认密码字段有值，重新验证
        if (this.editForm.newPassword) {
          this.$refs.editForm.validateField('newPassword')
        }
      }
    }
  },
  methods: {
    handleOpen(data) {
      this.editForm.id = data.id
      this.username = data.username
      this.dialogVisible = true
    },
    closeDialog() {
      this.$refs['editForm'].resetFields()
      this.dialogVisible = false
    },
    submitForm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {
            id: this.editForm.id,
            password: handleEncrpty(this.editForm.password)
          }
          this.$apis.system.resetPwd(params).then(res => {
            if (res) {
              this.$message({
                type: 'success',
                message: '密码重置成功！'
              })
              this.dialogVisible = false
            }
          })
        } else {
          return false
        }
      })
    },
    handlePwChange() {
      this.$refs.editForm.validateField('password')
      this.$refs.editForm.validateField('newPassword')
    },
    handleCancel() {
      this.editForm.newPassword = ''
      this.editForm.id = ''
      this.editForm.password = ''
      this.dialogVisible = false
    }
  }
}
</script>
<style scoped lang="scss">
.reset-password-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }
}
</style>
